import React from 'react';
import { useEffect } from 'react';

// CSS styles to be injected, including pseudo-elements and media queries
const injectedStyles = `
  .hero5-container::before {
    content: '';
    position: absolute;
    top: -20%;
    right: -20%;
    width: 800px;
    height: 800px;
    background-color: #eaf2ff; /* A very light blue */
    border-radius: 50%;
    z-index: 1;
  }

  @media (max-width: 992px) {
    .hero5-container {
      flex-direction: column;
      text-align: center;
    }
    .hero5-carousel-panel {
      margin-top: 3rem;
      justify-content: center;
    }
    .hero5-content-panel {
      align-items: center;
    }
    .hero5-container::before {
      width: 600px;
      height: 600px;
    }
  }
`;

const TemplateHero3 = ({ branding }) => {
  // Effect to inject styles for pseudo-elements and media queries
  useEffect(() => {
    const styleTag = document.createElement('style');
    styleTag.innerHTML = injectedStyles;
    document.head.appendChild(styleTag);
    return () => {
      document.head.removeChild(styleTag);
    };
  }, []);

  const styles = {
    heroContainer: {
      display: 'flex',
      alignItems: 'center',
      minHeight: '85vh',
      width: '100%',
      backgroundColor: '#f8f9fa',
      position: 'relative',
      overflow: 'hidden',
      padding: '2rem',
    },
    // Left side: Text content
    contentPanel: {
      flex: '1 1 50%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: '0 2rem',
      zIndex: 2, // Above the background shape
    },
    title: {
      fontFamily: 'var(--hero-title-font-family, "Merriweather", serif)',
      fontSize: '3.8rem',
      fontWeight: '700',
      lineHeight: '1.2',
      marginBottom: '1rem',
      color: '#2c3e50',
    },
    subtitle: {
      fontSize: '1.2rem',
      color: '#5a6d80',
      marginBottom: '2.5rem',
      maxWidth: '500px',
    },
    buttonGroup: {
      display: 'flex',
      gap: '1rem',
    },
    // Right side: Carousel
    carouselPanel: {
      flex: '1 1 50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: '0 2rem',
      zIndex: 2, // Above the background shape
    },
    carouselWrapper: {
      position: 'relative',
      width: '100%',
      maxWidth: '450px',
      height: '550px',
      borderRadius: '20px',
      boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
      overflow: 'hidden',
    },
    carouselImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    carouselNav: {
      position: 'absolute',
      bottom: '20px',
      right: '20px',
      display: 'flex',
      gap: '0.5rem',
    },
    navButton: {
      width: '50px',
      height: '50px',
      borderRadius: '50%',
      border: '1px solid rgba(255, 255, 255, 0.5)',
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      color: 'white',
      fontSize: '1.5rem',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }
  };

  return (
    <div style={styles.heroContainer} className="hero5-container">
      <div style={styles.contentPanel} className="hero5-content-panel">
        {/* --- Start of replaceable section --- */}
        <h1 style={styles.title}>Your Perfect Getaway is a Click Away</h1>
        <p style={styles.subtitle}>Discover thousands of destinations, from sunny beaches to snowy mountains, all curated just for you.</p>
        {/* --- End of replaceable section --- */}
        <div style={styles.buttonGroup}>
          <button className="btn btn-primary btn-lg rounded-pill px-4 py-2">View Packages</button>
          <button className="btn btn-outline-secondary btn-lg rounded-pill px-4 py-2">Contact Us</button>
        </div>
      </div>

      <div style={styles.carouselPanel} className="hero5-carousel-panel">
        <div style={styles.carouselWrapper}>
          <img 
            src="https://images.pexels.com/photos/2166553/pexels-photo-2166553.jpeg" 
            alt="Beautiful travel destination" 
            style={styles.carouselImage}
          />
          <div style={styles.carouselNav}>
            <button style={styles.navButton}>&#8249;</button>
            <button style={styles.navButton}>&#8250;</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateHero3;